
import React from "react";
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";

const NewUrgency = () => {
  return (
    <section className="section-padding bg-legatia-orange/10">
      <div className="container mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="section-title">
            Le temps est <span className="gradient-text">votre allié</span>
          </h2>
          
          <div className="flex justify-center mb-8">
            <div className="bg-legatia-orange/20 p-3 rounded-full">
              <Clock className="h-8 w-8 text-legatia-orange" />
            </div>
          </div>
          
          <p className="text-xl mb-8">
            Plus tôt vous commencez à créer ces ponts émotionnels, plus leur impact sera profond.
          </p>
          
          <div className="card-highlight mb-10">
            <p className="text-lg mb-4">
              Chaque message que vous enregistrez aujourd'hui devient un trésor émotionnel qui prend de la valeur avec le temps.
              Chaque contribution que vous faites aujourd'hui se transforme en un soutien significatif pour demain.
            </p>
            
            <p className="text-lg font-medium">
              En rejoignant Legatia maintenant, vous faites partie des pionniers d'une nouvelle façon de transmettre et de connecter les générations.
              Vous aurez accès à des fonctionnalités exclusives et à un accompagnement personnalisé pour créer des capsules temporelles émotionnelles qui marqueront l'histoire de votre famille.
            </p>
          </div>
          
          <Button 
            className="btn-primary"
            onClick={() => window.location.href = "https://app.getlegatia.ch/"}
          >
            Créer votre première capsule émotionnelle
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NewUrgency;
